import { Controller } from '@hotwired/stimulus';
import uniq from 'lodash-es/uniq';

export default class extends Controller {
  static targets = ['field', 'selector']

  connect() {
    this.refresh();
  }

  refresh() {
  }

  set(event) {
    let disciplines = this.fieldTarget.value.split(',').map(e => e.trim()).filter(e => e.length > 0);
    console.log(disciplines);
    disciplines.push(event.currentTarget.text);
    disciplines = uniq(disciplines);
    this.fieldTarget.value = disciplines.join(', ');
    this.refresh();
  }
}
